// extracted by mini-css-extract-plugin
module.exports = {"similarProfilesContainer":"style-module__similarProfilesContainer___paeOo","similarProfiles":"style-module__similarProfiles___84kC0"};